import API from 'utils/api';
import formatValues, { formatReceived } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/recaudacion/historiales-de-constancias-de-inscripciones/';

/**
 * GET Historiales de Constancia de Inscripcion
 * @param {Object} params
 * @returns {Promise<object[]>}
 */
export const getHistorialesDeConstancia = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (error) {
    onError(error);
    return [];
  }
};

/**
 * GET Historial de Constancia de Inscripcion
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getHistorialDeConstancia = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * POST Historial de Constancia de Inscripcion
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postHistorialDeConstancia = async (values) => {
  try {
    const response = await API.post(baseURI, formatValues(values, undefined, true));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Historial de Constancia de Inscripcion
  * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchHistorialDeConstancia = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}$/${id}`, formatValues(values, null, true));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Historial de Constancia de Inscripcion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteHistorialDeConstancia = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
